import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { InfoPanelService } from '@app/core/api/services/info-service.service';
import { LoadingService } from '@app/core/services/loading.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-info-panel',
    templateUrl: './info-panel.component.html',
    styleUrls: ['./info-panel.component.scss'],
    standalone: false
})
export class InfoPanelComponent implements OnInit, OnDestroy {
  data: InfoItem;
  isOpened: boolean;
  isLoading: boolean;

  destroy$: Subject<void> = new Subject();
  constructor(private infoPanelService: InfoPanelService, public sanitizer: DomSanitizer, private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.infoPanelService.infoPanelStateChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (!res) return;
      this.data = res.data;
      this.isOpened = res.isOpened
    });
    this.loadingService.loading$.pipe(takeUntil(this.destroy$)).subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  close() {
    this.infoPanelService.toggle();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}


export interface InfoItem {
  headerTitle: string;
  paragraph: string;
  links?: { title: string; sources: { name: string; src: string }[] };
  subSections?: InfoItem[];
}